/**
 * Tier 정보를 통일된 형식으로 변환합니다.
 *
 * @param tier - Tier 이름 (예: 'bronze', 'silver', 'gold')
 * @returns Tier 정보 객체
 */
export const buildTierInfo = (tier: string) => ({
  tagFQN: `Tier.${tier}`,
  name: tier,
  description: '',
});
